import React from "react";
import { Link, useNavigate } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();
  // const userName = sessionStorage.getItem("user_name");
  const logout = () => {
    sessionStorage.clear();
    navigate("/", { replace: true });
  };
  const profile = () => {
    navigate("/admin/profile");
  };

  return (
    <div className="header header-one hidden-print">
      <a className="mobile_btn" id="mobile_btn">
        <i className="fas fa-bars"></i>
      </a>
      <ul className="nav nav-tabs user-menu">
 
        <div className="dropdown">
          <button
            className="fe fe-user dropdown-toggle"
            type="button"
            id="dropdownMenuButton2"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          ></button>
          <ul
            className="dropdown-menu dropdown-menu-dark"
            aria-labelledby="dropdownMenuButton2"
          >
            {/* <li  className="fe fe-users">
              <a className="profile-icon" onClick={profile}>
                Profile
              </a>
            </li> */}
          
            <li className="fe fe-log-out">
              <a className="profile-icon " onClick={logout}>
                logout
              </a>
            </li>
          </ul>
        </div>
      </ul>
    </div>
  );
};

export default Header;
